import { IMinimizedBoxProps } from "./MinimizedBox.props";
import cn from "classnames";
import styles from "./MinimizedBox.module.scss";

export default function MinimizedBox(props: IMinimizedBoxProps) {
  if (!props.logs) return null;
  return (
    <div className={styles.wrapper} onClick={props.onClick}>
      <span>{props.logs}</span>
    </div>
  );
}
